import client from '@efex-services/axios';
import { CreateWalletParams, CreateWalletResponse } from './types';

const createWallet = async ({
  enterpriseId,
  currency,
}: CreateWalletParams): Promise<CreateWalletResponse> =>
  client.post(`balance/${enterpriseId}/wallet`, { currency });

const services = { createWallet };

export default services;
